import useDisclosure from '@/core/hooks/useDisclosure/useDisclosure';

export default useDisclosure;
